<template>
  <v-card style="margin:auto;margin-top:20px;" width="1200">

    <v-tabs
      background-color="#006699"
      color="white"
      right
    >
      <v-tab>Actividades diaria do caixa</v-tab>
      <v-tab>Actividades Filtradas</v-tab>
       <v-tab-item>
        <template>
            <v-card
              class="mx-auto"
               outlined
            >
             <v-card-title>Movimentações de Hoje</v-card-title>
             <v-card-text>
                <caixaDiaria></caixaDiaria>
             </v-card-text>

            </v-card>
          </template>
      </v-tab-item>
      <v-tab-item>
        <template>
            <v-card
              class="mx-auto"
               outlined
            >
             <v-card-title>Movimentações do caixa</v-card-title>
             <v-card-text>
                <caixaFiltrado></caixaFiltrado>
             </v-card-text>

            </v-card>
          </template>
      </v-tab-item>

    </v-tabs>
  </v-card>
</template>
<script>
import movimentacoesDiarias from './caixasMesasDiaria'
import movimentacoesFiltradas from './caixasMesasFiltrados'
export default {
  components: { 'caixaDiaria': movimentacoesDiarias, 'caixaFiltrado': movimentacoesFiltradas }
}
</script>
